import React from 'react';
import { Car, Route, CloudSun, MapPin } from 'lucide-react';

const Facilities = () => {
  return (
    <section id="facilities" className="relative py-16 sm:py-20 bg-gradient-to-br from-slate-50 to-blue-50 overflow-hidden kyle-section-compact">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-gradient-to-r from-[hsl(210,100%,45%)] to-[hsl(180,80%,45%)] text-white rounded-full text-sm font-black mb-6 shadow-xl">
            <span>🏢</span>
            <span>THE VENUE</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[hsl(210,100%,12%)] mb-4">
            Kyle Rise Car Park
          </h2>
          <p className="text-base sm:text-lg text-gray-700 max-w-2xl mx-auto leading-relaxed">
            Our dedicated training facility in Ayr
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 items-center">
          {/* Training facility image */}
          <div className="relative group">
            <div className="absolute -inset-4 bg-gradient-to-br from-cyan-500/20 to-teal-500/20 rounded-3xl blur-2xl group-hover:blur-3xl transition-all" />
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white">
              <img
                src="/redesign/new-15.png"
                alt="Kyle Rise Car Park training area with pedestrian crossing"
                className="w-full h-[400px] object-cover group-hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>

          {/* Features list */}
          <div className="space-y-6">
            <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all border-2 border-gray-100 hover:border-cyan-400">
              <div className="flex-shrink-0 w-14 h-14 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-full flex items-center justify-center text-white font-black text-xl shadow-lg">
                <Car className="w-7 h-7 kyle-icon-bounce" aria-hidden="true" />
              </div>
              <div>
                <h3 className="text-xl font-black text-[hsl(210,100%,12%)] mb-2">Private Multi-Storey Car Park</h3>
                <p className="text-gray-700 leading-relaxed">Dedicated training environment, completely traffic-free and safe.</p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all border-2 border-gray-100 hover:border-teal-400">
              <div className="flex-shrink-0 w-14 h-14 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-full flex items-center justify-center text-white font-black text-xl shadow-lg">
                <Route className="w-7 h-7 kyle-icon-pulse kyle-icon-delay-1" aria-hidden="true" />
              </div>
              <div>
                <h3 className="text-xl font-black text-[hsl(210,100%,12%)] mb-2">Real Road Infrastructure</h3>
                <p className="text-gray-700 leading-relaxed">Traffic lights, junctions, roundabouts, parking bays, and road markings.</p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all border-2 border-gray-100 hover:border-blue-400">
              <div className="flex-shrink-0 w-14 h-14 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-full flex items-center justify-center text-white font-black text-xl shadow-lg">
                <CloudSun className="w-7 h-7 kyle-icon-bounce kyle-icon-delay-2" aria-hidden="true" />
              </div>
              <div>
                <h3 className="text-xl font-black text-[hsl(210,100%,12%)] mb-2">All-Weather Training</h3>
                <p className="text-gray-700 leading-relaxed">Multi-storey covered levels — rain, wind or shine, we're always ready.</p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all border-2 border-gray-100 hover:border-purple-400">
              <div className="flex-shrink-0 w-14 h-14 bg-gradient-to-br from-purple-500 to-blue-500 rounded-full flex items-center justify-center text-white font-black text-xl shadow-lg">
                <MapPin className="w-7 h-7 kyle-icon-pulse kyle-icon-delay-3" aria-hidden="true" />
              </div>
              <div>
                <h3 className="text-xl font-black text-[hsl(210,100%,12%)] mb-2">Convenient Location</h3>
                <p className="text-gray-700 leading-relaxed">Easy access in Ayr town centre with ample parking for parents.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Facilities;
